module.exports = __webpack_public_path__ + "img/express.d92b3df.jpg";